export enum TimeSlotOwner {
  HUBLER = 'HUBLER',
  GTA = 'GTA',
  SHIFT = 'SHIFT',
}
